import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-buttons',
	templateUrl: './buttons.component.html',
	styleUrls: ['./buttons.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ButtonsComponent implements OnInit {

	constructor(private _titleService: Title) {
		_titleService.setTitle('Buttons');
	}

	ngOnInit() {
	
	}

	ngOnDestroy(): void {
	}


}



// WEBPACK FOOTER //
// ./src/app/features/buttons/buttons.component.ts